import {React,useEffect} from 'react';
import Article from "./Article3.png"
import { Container,AppBar } from '@mui/material';


const headingStyle = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '16px',
  color: '#221F1F',
  lineHeight: '36px',
};

const titleStyle = {
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: '32px',
  color: '#31B9B5',
  lineHeight: '53.25px',
};

const paragraphStyle = {
  fontFamily: 'DM Sans',
  fontWeight: 400,
  fontSize: '16px',
  color: '#222222BF',
  lineHeight: '40.73px',
  textAlign: 'justify',
};
const ArticlePage3 = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



const ConventionalLoan = () => {
  return (
    
    <div>
      <h3 style={headingStyle}>1. Conventional Loan</h3>
      <p style={paragraphStyle}>
        Conventional loans, which are not backed by the federal government, come in two forms: conforming and non-conforming.
      </p>
      <h4 style={headingStyle}>Conforming loans</h4>
      <p style={paragraphStyle}>
        As the name implies, a conforming loan "conforms" to the set of standards put in place by the Federal Housing Finance Agency (FHFA), which includes credit, debt, and loan size. For 2023, the conforming loan limits are $726,200 in most areas and $1,089,300 in high-cost areas.
      </p>
      <h4 style={headingStyle}>Non-conforming loans</h4>
      <p style={paragraphStyle}>
        These loans do not meet FHFA standards. Instead, they cater to borrowers looking to purchase more expensive homes or individuals with unusual credit profiles.
      </p>
      <h4 style={headingStyle}>Pros of conventional loans</h4>
      <ul>
        <li style={paragraphStyle}>Can be used for a primary home, second home, or investment property</li>
        <li style={paragraphStyle}>Overall borrowing costs tend to be lower than other types of mortgages, even if interest rates are slightly higher</li>
        <li style={paragraphStyle}>Can ask your lender to cancel private mortgage insurance (PMI) once you've reached 20 percent equity, or refinance to remove it</li>
        <li style={paragraphStyle}>Can pay as little as 3 percent down on loans backed by Fannie Mae or Freddie Mac</li>
        <li style={paragraphStyle}>Sellers can contribute to closing costs</li>
      </ul>
      <h4 style={headingStyle}>Cons of conventional loans</h4>
      <ul>
        <li style={paragraphStyle}>Minimum FICO score of 620 or higher is often required (the same applies for refinancing)</li>
        <li style={paragraphStyle}>Higher down payment than some government loans</li>
        <li style={paragraphStyle}>Must have a debt-to-income (DTI) ratio of no more than 45 percent (50 percent in some instances)</li>
        <li style={paragraphStyle}>Likely need to pay PMI if your down payment is less than 20 percent of the sales price</li>
        <li style={paragraphStyle}>Significant documentation required to verify income, assets, down payment, and employment</li>
      </ul>
      <h4 style={headingStyle}>Who are conventional loans best for?</h4>
      <p style={paragraphStyle}>
        If you have a strong credit score and can afford to make a sizable down payment, a conventional mortgage is probably your best pick. The 30-year, fixed-rate mortgage is the most popular choice for homebuyers.
      </p>
    </div>
  );
};

const FixedRateMortgage = () => {
  return (
    <div>
      <h3 style={headingStyle}>2. Fixed-rate Mortgage</h3>
      <p style={paragraphStyle}>
        Fixed-rate mortgages maintain the same interest rate over the life of your loan, which means your monthly mortgage payment always stays the same. Fixed loans typically come in terms of 15 years or 30 years, although some lenders allow borrowers to pick any term between eight and 30 years.
      </p>
      <h4 style={headingStyle}>Pros of fixed-rate mortgages</h4>
      <ul>
        <li style={paragraphStyle}>Monthly principal and interest payments stay the same throughout the life of the loan</li>
        <li style={paragraphStyle}>Easier to budget housing expenses from month to month</li>
      </ul>
      <h4 style={headingStyle}>Cons of fixed-rate mortgages</h4>
      <ul>
        <li style={paragraphStyle}>If interest rates fall, you'll have to refinance to get that lower rate</li>
        <li style={paragraphStyle}>Interest rates typically higher than rates on adjustable-rate mortgages (ARMs)</li>
      </ul>
      <h4 style={headingStyle}>Who are fixed-rate mortgages best for?</h4>
      <p style={paragraphStyle}>
        If you are planning to stay in your home for at least five to seven years and want to avoid the potential for changes to your monthly payments, a fixed-rate mortgage is right for you.
      </p>
    </div>
  );
};

const AdjustableRateMortgage = () => {
  return (
    <div>
      <h3 style={headingStyle}>3. Adjustable-rate Mortgage (ARM)</h3>
      <p style={paragraphStyle}>
        In contrast to fixed-rate loans, adjustable-rate mortgages (ARMs) have interest rates that fluctuate with market conditions. Many ARM products have a fixed interest rate for a few years before the loan changes to a variable interest rate for the remainder of the term. For example, you might see a 7/6 ARM, which means that your rate will remain the same for the first seven years and will adjust every six months after that initial period. If you consider an ARM, it's essential to read the fine print to know how much your rate can increase and how much you could wind up paying after the introductory period expires.
      </p>
      <h4 style={headingStyle}>Pros of ARMs</h4>
      <ul>
        <li style={paragraphStyle}>Lower fixed rate in the first few years of homeownership (although this isn't a guarantee; as of late, 30-year fixed rates have actually been similar to those for 5/6 ARMs)</li>
        <li style={paragraphStyle}>Can save a substantial amount of money on interest payments</li>
      </ul>
      <h4 style={headingStyle}>Cons of ARMs</h4>
      <ul>
        <li style={paragraphStyle}>Monthly mortgage payments could become unaffordable, resulting in a loan default</li>
        <li style={paragraphStyle}>Home values may fall in a few years, making it harder to refinance or sell before the loan resets</li>
      </ul>
      <h4 style={headingStyle}>Who are adjustable-rate mortgages best for?</h4>
      <p style={paragraphStyle}>
        If you don't plan to stay in your home beyond a few years, an ARM could help you save on interest payments. However, it's important to be comfortable with a certain level of risk that your payments might increase if you're still in the home.
      </p>
    </div>
  );
};

const JumboLoan = () => {
  return (
    <div>
      <h3 style={headingStyle}>4. Jumbo Loan</h3>
      <p style={paragraphStyle}>
        Jumbo mortgages are home loan products that fall outside FHFA borrowing limits. Jumbo loans are more common in higher-cost areas such as Los Angeles, San Francisco, New York City, and the state of Hawaii, where home prices are often on the higher end.
      </p>
      <h4 style={headingStyle}>Pros of jumbo loans</h4>
      <ul>
        <li style={paragraphStyle}>Can borrow more money to purchase a more expensive home</li>
        <li style={paragraphStyle}>Interest rates tend to be competitive with other conventional loans</li>
        <li style={paragraphStyle}>Often the only finance option in areas with extremely high home values</li>
      </ul>
      <h4 style={headingStyle}>Cons of jumbo loans</h4>
      <ul>
        <li style={paragraphStyle}>Down payment of at least 10 percent to 20 percent required in many cases</li>
        <li style={paragraphStyle}>A FICO score of 700 or higher usually required</li>
        <li style={paragraphStyle}>Cannot have a DTI ratio above 45 percent</li>
        <li style={paragraphStyle}>Must show you have significant assets in cash or savings accounts</li>
        <li style={paragraphStyle}>Usually require more in-depth documentation to qualify</li>
      </ul>
      <h4 style={headingStyle}>Who are jumbo loans best for?</h4>
      <p style={paragraphStyle}>
        If you're looking to finance a home with a selling price exceeding the latest conforming loan limits, a jumbo loan is likely your best route.
      </p>
    </div>
  );
};
const GovernmentInsuredLoan = () => {
  return (
    <div>
      <h3 style={headingStyle}>5. Government-insured Loan</h3>
      <p style={paragraphStyle}>
        The U.S. government isn't a mortgage lender, but it does play a role in making homeownership accessible to more Americans by guaranteeing certain types of loans — thus lessening the risk for lenders. Three government agencies back mortgages: the Federal Housing Administration (FHA), the U.S. Department of Agriculture (USDA), and the U.S. Department of Veterans Affairs (VA).
      </p>
      <h4 style={headingStyle}>FHA loans</h4>
      <p style={paragraphStyle}>
        Backed by the FHA, these home loans come with competitive interest rates and help make homeownership possible for borrowers without a large down payment or pristine credit. You'll need a minimum FICO score of 580 to get the FHA maximum of 96.5 percent financing with a 3.5 percent down payment. However, a score as low as 500 is allowed if you put at least 10 percent down. FHA loans require mortgage insurance premiums, which can increase the overall cost of your mortgage. Lastly, with an FHA loan, the home seller is allowed to contribute to closing costs.
      </p>
      <h4 style={headingStyle}>USDA loans</h4>
      <p style={paragraphStyle}>
        USDA loans help moderate- to low-income borrowers who meet certain income limits buy homes in rural, USDA-eligible areas. Some USDA loans do not require a down payment for eligible borrowers. There are extra fees, though, including an upfront fee of 1 percent of the loan amount (which can typically be financed with the loan) and an annual fee.
      </p>
      <h4 style={headingStyle}>VA loans</h4>
      <p style={paragraphStyle}>
        VA loans provide flexible, low-interest mortgages for members of the U.S. military (active duty and veterans) and their families. There's no minimum down payment, mortgage insurance, or credit score requirement, and closing costs are generally capped and may be paid by the seller. VA loans charge a funding fee, a percentage of the loan amount, which can be paid upfront at closing or rolled into the cost of the loan along with other closing costs.
      </p>
      <h4 style={headingStyle}>Pros of government-insured loans</h4>
      <ul>
        <li style={paragraphStyle}>Help you finance a home when you don't qualify for a conventional loan</li>
        <li style={paragraphStyle}>Credit requirements more relaxed</li>
        <li style={paragraphStyle}>Don't need a large down payment</li>
        <li style={paragraphStyle}>Available to repeat and first-time buyers</li>
        <li style={paragraphStyle}>No mortgage insurance and no down payment required for VA loans</li>
      </ul>
      <h4 style={headingStyle}>Cons of government-insured loans</h4>
      <ul>
        <li style={paragraphStyle}>Mandatory mortgage insurance premiums on FHA loans that usually cannot be canceled</li>
        <li style={paragraphStyle}>FHA loan sizes are lower than conventional mortgages in most areas, limiting potential inventory to choose from</li>
        <li style={paragraphStyle}>Borrower must live in the property (although you may be able to finance a multi-unit building and rent out other units)</li>
        <li style={paragraphStyle}>Could have higher overall borrowing costs</li>
        <li style={paragraphStyle}>Expect to provide more documentation, depending on the loan type, to prove eligibility</li>
      </ul>
      <h4 style={headingStyle}>Who are government-insured loans best for?</h4>
      <p style={paragraphStyle}>
        Are you having trouble qualifying for a conventional loan due to a lower credit score or minimal cash reserves for a down payment? FHA-backed and USDA-backed loans could be a viable option. For military service members, veterans, and eligible spouses, VA-backed loan terms are often more generous than a conventional loan's.
      </p>
    </div>
  );
};

  return (
    <Container maxWidth="xl" className="articleContainer">
<div>
    <img src={Article} alt="Article 2" style={{maxWidth: '100%',
    height: 'auto',
    marginTop: '50px'}} />
    
    <div>
      <h1 style={titleStyle}>Mortgage Loan Types</h1>
      <p style={paragraphStyle}>A new home may be one of the biggest purchases you’ll make in your life. Before you begin shopping for the right home to buy, you’ll probably need to explore mortgage options.</p>
      <p style={paragraphStyle}>Not all home loans are the same, though. So, doing your research before moving forward can help you select the most suitable option for your financial situation and possibly keep more money in your pocket. Plus, you’ll know what to expect, in terms of guidelines, when you apply.</p>

      <h2 style={headingStyle}>Types of Mortgages</h2>
      <ul>
        <li><ConventionalLoan /></li>
        <li><FixedRateMortgage /></li>
        <li><AdjustableRateMortgage /></li>
        <li><JumboLoan /></li>
        <li><GovernmentInsuredLoan /></li>
      </ul>
    </div>
    </div>
    </Container>
  );
};

export default ArticlePage3;
